import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfig } from '../../app/app.config';

@Injectable({
  providedIn: 'root'
})
export class ExploreService {
  private showExploreTabSubject = new BehaviorSubject<boolean>(false);
  public showExploreTab$: Observable<boolean> = this.showExploreTabSubject.asObservable();

  constructor(private appConfig: AppConfig) {}

  /**
   * Handles the explore tab experiment logic
   * @param experiments - List of experiments
   * @param userOrderState - User's order state
   */
  handleExploreTabExperiment(experiments: any[], userOrderState: string): void {
    const exploreExperiment = experiments.find((experiment: any) => experiment.key === 'explore_tab');

    const isEnabled = exploreExperiment?.enable;
    const variants = exploreExperiment?.variant;

    // If experiment is not enabled or no variants, keep showExploreTab true and return
    if (!isEnabled || !variants) {
      this.showExploreTabSubject.next(true);
      return;
    }

    // Only perform calculations when experiment is enabled
    const isRetentionUser = userOrderState === this.appConfig.Shared.User.OrderState.DELIVERED;
    this.showExploreTabSubject.next(isRetentionUser ? variants.ret : variants.acq);
  }

  /**
   * Get current value of showExploreTab
   */
  getShowExploreTab(): boolean {
    return this.showExploreTabSubject.value;
  }
}
